import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-651b22a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "group-first" }
const _hoisted_2 = { class: "group-left" }
const _hoisted_3 = { class: "group-left" }
const _hoisted_4 = { class: "group-first" }
const _hoisted_5 = { class: "group-left" }
const _hoisted_6 = { class: "group-right" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "line-block" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub-title" }, "s2e", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rate-description" }, [
  /*#__PURE__*/_createElementVNode("p", null, "ex"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("p", { class: "item" }, "When Earn Rate is 0.05"),
      /*#__PURE__*/_createElementVNode("ul", null, [
        /*#__PURE__*/_createElementVNode("li", null, "The income = (watched hours * 0.05)")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("p", { class: "item" }, "When Earn Rate is 0.025"),
      /*#__PURE__*/_createElementVNode("ul", null, [
        /*#__PURE__*/_createElementVNode("li", null, "The income = (watched hours *0.025)")
      ])
    ])
  ])
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rate-description" }, [
  /*#__PURE__*/_createElementVNode("p", null, "ex"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("p", { class: "item" }, "When Earn Rate is 0.02"),
      /*#__PURE__*/_createElementVNode("ul", null, [
        /*#__PURE__*/_createElementVNode("li", null, "The income = (watched hours * 0.02)")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("p", { class: "item" }, "When Earn Rate is 0.01"),
      /*#__PURE__*/_createElementVNode("ul", null, [
        /*#__PURE__*/_createElementVNode("li", null, "The income = (watched hours *0.01)")
      ])
    ])
  ])
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "line-block" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub-title" }, "w2e", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub-title" }, "Exception", -1))
const _hoisted_14 = { class: "group-first" }
const _hoisted_15 = { class: "group-left" }
const _hoisted_16 = { class: "group-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_base_form_validator = _resolveComponent("base-form-validator")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_base_upload = _resolveComponent("base-upload")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_base_select = _resolveComponent("base-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_get_channel_y_t = _resolveComponent("get-channel-y-t")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_modal, {
      onOk: _ctx.onSubmit,
      onCancel: _ctx.onCancel,
      style: {"width":"680px"},
      visible: _ctx.visible,
      "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.visible) = $event)),
      confirmLoading: _ctx.loading,
      title: _ctx.$t('module.stream.create'),
      "ok-text": _ctx.$t('common.add'),
      "cancel-text": _ctx.$t('common.cancel')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: _ctx.streamer,
          "validate-messages": _ctx.validateMessages,
          ref: "form"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_base_form_validator, {
                  label: _ctx.$t('module.stream.create_streamer.streamer_name'),
                  name: "streamer_name",
                  class: "streamer_name"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _ctx.streamer.streamer_name,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.streamer.streamer_name) = $event)),
                      placeholder: "Enter streamer name"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_base_form_validator, {
                  label: _ctx.$t('module.stream.create_streamer.partner_status'),
                  name: "is_partner",
                  rules: [{ required: true }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: _ctx.streamer.is_partner,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.streamer.is_partner) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select_option, { value: true }, {
                          default: _withCtx(() => [
                            _createTextVNode("Partner")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: false }, {
                          default: _withCtx(() => [
                            _createTextVNode("Non-Partner")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_base_form_validator, {
                  label: _ctx.$t('module.stream.create_streamer.status'),
                  name: "status",
                  rules: [{ required: true }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: _ctx.streamer.status,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.streamer.status) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select_option, { value: "disabled" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Disabled")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: "enabled" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Enabled")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ])
            ]),
            _createVNode(_component_base_form_validator, {
              label: _ctx.$t('module.stream.create_streamer.about'),
              name: "description"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: _ctx.streamer.description,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.streamer.description) = $event)),
                  rows: "4",
                  placeholder: "Tell us about this streamer"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_base_form_validator, {
                  label: _ctx.$t('module.stream.create_streamer.twitch_login'),
                  name: "twitch_login",
                  class: _normalizeClass([{ 'ant-form-item-has-error': _ctx.errorClass }, "twitch_login"])
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _ctx.streamer.twitch_login,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.streamer.twitch_login) = $event)),
                      placeholder: "Enter Twitch ID (Must enter at least 1 Twitch or Youtube ID)"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["label", "class"]),
                _createVNode(_component_base_form_validator, {
                  label: _ctx.$t('module.stream.create_streamer.youtube_channel_id'),
                  name: "youtube_channel_id",
                  class: _normalizeClass([{ 'ant-form-item-has-error': _ctx.errorClass }, "youtube_channel_id"])
                }, {
                  extra: _withCtx(() => [
                    _createElementVNode("a", {
                      href: "javascript:void(0)",
                      class: "text-italic mr-24",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$refs.getChannelYT.show()))
                    }, "Get channel id Youtube")
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _ctx.streamer.youtube_channel_id,
                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.streamer.youtube_channel_id) = $event)),
                      placeholder: "Enter Youtube ID (Must enter at least 1 Twitch or Youtube ID)"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["label", "class"]),
                (_ctx.streamer.youtube_channel_id)
                  ? (_openBlock(), _createBlock(_component_base_form_validator, {
                      key: 0,
                      label: _ctx.$t('module.stream.create_streamer.category'),
                      name: "default_category",
                      rules: [{ required: true }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: _ctx.streamer.default_category,
                          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.streamer.default_category) = $event)),
                          placeholder: "Select category"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryGame, (item, key) => {
                              return (_openBlock(), _createBlock(_component_a_select_option, {
                                value: key,
                                key: key
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["label"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_base_form_validator, {
                  label: _ctx.$t('module.stream.create_streamer.avatar'),
                  name: "profile_image_url"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_upload, {
                      images: _ctx.streamer.profile_image_url,
                      "onUpdate:images": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.streamer.profile_image_url) = $event)),
                      number: 1
                    }, null, 8, ["images"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ])
            ]),
            _hoisted_7,
            _hoisted_8,
            _createVNode(_component_base_form_validator, {
              class: "mb-3",
              label: _ctx.$t('module.stream.create_streamer.stream_to_earn_rate_live'),
              name: "s2e_token_amount_per_hour",
              rules: [{ type: 'number', min: 0, message: '${label} cannot be less than ${min}'}, { type: 'number', max: 1000000, message: '${label} cannot be greater than ${max}' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_number, {
                  value: _ctx.streamer.s2e_token_amount_per_hour,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.streamer.s2e_token_amount_per_hour) = $event)),
                  class: "override-input-number",
                  placeholder: "Stream To Earn Rate (Live)",
                  step: 0.01,
                  formatter: value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                  parser: value => value.replace(/\$\s?|(,*)/g, '')
                }, null, 8, ["value", "step", "formatter", "parser"])
              ]),
              _: 1
            }, 8, ["label"]),
            _hoisted_9,
            _createVNode(_component_base_form_validator, {
              class: "mb-3",
              label: _ctx.$t('module.stream.create_streamer.stream_to_earn_rate_past'),
              name: "s2e_token_amount_per_hour_for_video",
              rules: [{ type: 'number', min: 0, message: '${label} cannot be less than ${min}'}, { type: 'number', max: 1000000, message: '${label} cannot be greater than ${max}' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_number, {
                  value: _ctx.streamer.s2e_token_amount_per_hour_for_video,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.streamer.s2e_token_amount_per_hour_for_video) = $event)),
                  class: "override-input-number",
                  placeholder: "Stream To Earn Rate (Past)",
                  step: 0.01,
                  formatter: value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                  parser: value => value.replace(/\$\s?|(,*)/g, '')
                }, null, 8, ["value", "step", "formatter", "parser"])
              ]),
              _: 1
            }, 8, ["label"]),
            _hoisted_10,
            _hoisted_11,
            _hoisted_12,
            _createVNode(_component_base_form_validator, {
              label: _ctx.$t('module.stream.create_streamer.livestream_reward'),
              name: "stream_reward_id",
              rules: [{ required: true }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_base_select, {
                  value: _ctx.streamer.stream_reward_id,
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.streamer.stream_reward_id) = $event)),
                  placeholder: "Select a reward amount per hour",
                  "use-load-more": {
            active: true,
            url: '/bo/api/v1/rewards',
            key: 'rewards',
            firstLoader: true,
            option: {
              search: 'search_text',
              value: 'id',
              title: 'djt_amount_per_hour'
            }
          }
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_base_form_validator, {
              label: _ctx.$t('module.stream.create_streamer.video_reward'),
              name: "video_reward_id",
              rules: [{ required: true }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_base_select, {
                  placeholder: "Select a reward amount per hour",
                  value: _ctx.streamer.video_reward_id,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.streamer.video_reward_id) = $event)),
                  "use-load-more": {
            active: true,
            url: '/bo/api/v1/rewards',
            key: 'rewards',
            option: {
              search: 'search_text',
              value: 'id',
              title: 'djt_amount_per_hour'
            }
          }
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 8, ["label"]),
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_base_form_validator, {
                  label: _ctx.$t('module.stream.create_streamer.affiliate'),
                  name: "affiliate",
                  rules: [{ required: false }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: _ctx.streamer.affiliate,
                      "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.streamer.affiliate) = $event)),
                      placeholder: "Select a affiliate",
                      allowClear: "",
                      "show-search": ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.affiliates, (affiliate) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: affiliate.affiliateId,
                            value: affiliate.agentCode
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(affiliate.agentName), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_base_form_validator, {
                  label: _ctx.$t('module.stream.create_streamer.live_stream_rewards_per_hour'),
                  name: "affiliate_stream_reward_id",
                  rules: [{ required: false }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_select, {
                      value: _ctx.streamer.affiliate_stream_reward_id,
                      "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.streamer.affiliate_stream_reward_id) = $event)),
                      placeholder: "Select a reward amount per hour",
                      "use-load-more": {
                active: true,
                url: '/bo/api/v1/rewards',
                key: 'rewards',
                firstLoader: true,
                option: {
                  search: 'search_text',
                  value: 'id',
                  title: 'djt_amount_per_hour'
                }
              }
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_base_form_validator, {
                  label: _ctx.$t('module.stream.create_streamer.past_stream_rewards_per_hour'),
                  name: "affiliate_video_reward_id",
                  rules: [{ required: false }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_select, {
                      placeholder: "Select a reward amount per hour",
                      value: _ctx.streamer.affiliate_video_reward_id,
                      "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.streamer.affiliate_video_reward_id) = $event)),
                      "use-load-more": {
                active: true,
                url: '/bo/api/v1/rewards',
                key: 'rewards',
                option: {
                  search: 'search_text',
                  value: 'id',
                  title: 'djt_amount_per_hour'
                }
              }
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["model", "validate-messages"])
      ]),
      _: 1
    }, 8, ["onOk", "onCancel", "visible", "confirmLoading", "title", "ok-text", "cancel-text"]),
    _createVNode(_component_get_channel_y_t, {
      ref: "getChannelYT",
      onSubmit: _cache[17] || (_cache[17] = value => (_ctx.streamer.youtube_channel_id = value))
    }, null, 512)
  ], 64))
}